import { render } from "./gorusmebilgiCard.vue?vue&type=template&id=39bcb46d"
import script from "./gorusmebilgiCard.vue?vue&type=script&lang=js"
export * from "./gorusmebilgiCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__